import ChargerModule from 'components/chargerModule';
import QuoteEditorModule from './components/QuoteEditorModule/QuoteEditorModule';
import './QuoteEditor.scss';

interface IQuoteEditor {}

/**
 * Vista raíz del editor de cotización. Provee el contenedor ChargerModule
 * y delega toda la lógica a QuoteEditorModule.
 */
const QuoteEditor = ({}: IQuoteEditor) => {
  const HEADER_INFO = { title: 'Cotizaciones', subtitle: 'Detalle de cotización / Editar cotización' };

  return (
    <ChargerModule
      headerInfo={HEADER_INFO}
      infoSideBar={{ position: 'quote' }}
      hideSidebar
      containerId="quoteEditorContainer"
    >
      <QuoteEditorModule />
    </ChargerModule>
  );
};

export default QuoteEditor;
